// Metrics exports deliberately use fixed allowlists. Never traverse a result
// object: it also contains equity curves and trades, which are view-only
// derived artifacts and must not leak into a downloadable data file.

const BACKTEST_OVERALL = [
  ['totalReturn', 'Total return', 'percent'],
  ['cagr', 'CAGR', 'percent'],
  ['sharpe', 'Sharpe ratio', 'ratio'],
  ['maxDrawdown', 'Maximum drawdown', 'percent'],
  ['volatility', 'Volatility', 'percent'],
  ['winRate', 'Win rate', 'percent'],
  ['profitFactor', 'Profit factor', 'ratio'],
  ['calmar', 'Calmar ratio', 'ratio'],
  ['trades', 'Trade count', 'count'],
  ['avgHoldDays', 'Average holding period', 'days'],
];

const BACKTEST_YEARLY = [
  ['return', 'Return', 'percent'],
  ['sharpe', 'Sharpe ratio', 'ratio'],
  ['maxDrawdown', 'Maximum drawdown', 'percent'],
  ['winRate', 'Win rate', 'percent'],
  ['trades', 'Trade count', 'count'],
];

const PORTFOLIO_RISK = [
  ['volatility', 'Annualized volatility', 'percent'],
  ['maxDrawdown', 'Maximum drawdown', 'percent'],
  ['herfindahl', 'Concentration (HHI)', 'ratio'],
  ['avgCorrelation', 'Average correlation', 'ratio'],
  ['observations', 'Aligned return observations', 'count'],
];

function csvCell(value) {
  const text = String(value ?? '');
  return /[",\n]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text;
}

function csv(rows) {
  return `${rows.map((row) => row.map(csvCell).join(',')).join('\n')}\n`;
}

function appendAllowed(rows, source, definitions, scope, period = '') {
  for (const [key, label, unit] of definitions) {
    const value = source?.[key];
    if (value === null || value === undefined || value === '' || !Number.isFinite(Number(value))) continue;
    rows.push([scope, period, label, Number(value), unit]);
  }
}

export function buildBacktestMetricsCsv(result) {
  const rows = [['scope', 'period', 'metric', 'value', 'unit']];
  appendAllowed(rows, result?.metrics?.overall, BACKTEST_OVERALL, 'overall');
  for (const yearly of result?.metrics?.byYear || []) {
    const year = Number(yearly?.year);
    if (!Number.isInteger(year) || year < 1900 || year > 2200) continue;
    appendAllowed(rows, yearly, BACKTEST_YEARLY, 'yearly', year);
  }
  return csv(rows);
}

export function buildPortfolioRiskMetricsCsv(metrics) {
  const period = metrics?.period?.from && metrics?.period?.to
    ? `${metrics.period.from} to ${metrics.period.to}`
    : '';
  const rows = [['scope', 'period', 'metric', 'value', 'unit']];
  appendAllowed(rows, metrics, PORTFOLIO_RISK, 'portfolio', period);
  return csv(rows);
}

export function downloadMetricsCsv(content, filename) {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
